import { render, staticRenderFns } from "./ActivityBusinessRisksTable.vue?vue&type=template&id=6a476f8b&"
import script from "./ActivityBusinessRisksTable.vue?vue&type=script&lang=js&"
export * from "./ActivityBusinessRisksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports